<template>
    <button
		v-if="visibility"
		@click="$emit('click')"
		class="rp-reorder-product"
		:disabled="disabled || isLoading || !!error"
		:style="{
			color: textColor,
			border:'1px solid',
			borderColor: borderColor,
			backgroundColor: backgroundColor,
			borderRadius:'0px'
		}"
		:class="{'rp-form-error': !!error}"
	>	
		<rp-dot-loader v-if="isLoading" :dotColor="buttonType === 'filled' ? textColor : ''" />
        <div class="button-label" :class="isLoading ? 'hide-the-element': ''">
			{{ error || label || 'REORDER' }}
			<i v-if="!error && icon" class="rp-messenger-login-enter-icon" :class="icon" />
        </div>
    </button>
</template>

<script>

export default {

	props: {

		label: String,
		buttonType: {
			type: String,
			required: false,
			default: 'outline',
		},

		disabled: {
			type: Boolean,
			default: false,
		},

		isLoading: {
			type: Boolean,
			default: false,
		},

		error: {
			type: String,
			default: '',
		},
		
		icon: {
			type: String,
			default: '',
		}

	},

	computed: {

		activeColor() {
			try {
				return this.$root.configuration.style.activeColor;
			}catch(e){
				return '#296df6';
			}
		},
		textColor() {
			if(this.buttonType === 'filled')
				return '#ffffff';
			return this.activeColor;
		},
		backgroundColor() {
			if(this.buttonType === 'filled')
				return this.activeColor
			return '#ffffff';
				
		},
		borderColor() {
			return this.activeColor
		},

		visibility() {
			if(!this.label || this.label === 'REORDER') return false;
			//let's hide this button for now. We can enable it once the reorder api is ready
			//return false;
			try{
				return this.$root.configuration.control.canCreateNewConversations;
			}
			catch(e) {
				return true
			}
		},
	}
}

</script>

<style lang="scss">
.rp-reorder-product {
	background: #fff;
	padding: 10px 24px !important;
	// border-radius: 4px;
	color: white;
	font-size: 12px;
	word-spacing: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	.rp-messenger-login-enter-icon {
		padding-left: 10px;
		font-size: 20px;
	}
	.rp-loading-dots {
		position: absolute;
	}
	.hide-the-element {
		visibility: hidden;
	}
	.button-label {
		display: flex;
		font-weight: 500;
		padding-left: 0px;
		font-size: 14px;
		@include for-size(desktop-up){
			font-size: 16px;
		}
		font-family: $font;
		i {
			font-weight: bold;
		}
	}

	.icon {
		width: 15px;
		height: 15px;

		svg {
			display: block;
		}
	}

	&.small {
		padding: .6rem 1.5rem;
		font-size: 12px;

		.icon {
			width: 12px;
			height: 12px;
		}
	}
	+.rp-reorder-product {
		margin-left: 1rem;
	}
	&.rp-form-error {
		animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
		transform: translate3d(0, 0, 0);
		backface-visibility: hidden;
		perspective: 1000px;
		background-color: #ff0000 !important;
		border-color:  #ff0000 !important;
		color: #fff !important;
		opacity: 0.8 !important;
		font-size: 14px;
		transition: 0.3s opacity ease-in;
		.text {
			//   animation: text-appear 0.5s
			// transition: 0.3s opacity ease-in;
			// transform: scaleY(1) translateZ(0);
			// transform-origin: 50% 50%;
		}
		&:hover, 
		&:focus  {
			background-color: #ff0000 !important;
			border-color:  #ff0000 !important;
			color: #fff !important;
		}
		}

		@keyframes shake {
			10%, 90% {
				transform: translate3d(-1px, 0, 0);
			}
			
			20%, 80% {
				transform: translate3d(2px, 0, 0);
			}

			30%, 50%, 70% {
				transform: translate3d(-4px, 0, 0);
			}

			40%, 60% {
				transform: translate3d(4px, 0, 0);
			}
		}

		@keyframes text-appear {
			0% {
				transform: translateX(0);
				opacity: 0;
			}
			50% {
				transform: translateX(1.5);
			}
			100% {
				transform: translateX(1);
			}
		}
}
</style>
